module.exports = __webpack_public_path__ + "img/header-bg-pad.bc987ef9.png";